import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { Card } from '../../models/card';
import { CardBookingCtaComponent } from '../card-booking-cta/card-booking-cta.component';

@Component({
  selector: 'ten-card-bottom',
  templateUrl: './card-bottom.component.html',
  styleUrls: ['./card-bottom.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass, CardBookingCtaComponent, MatIconModule, MatButtonModule, NgIf, TranslateModule, SafeHtmlPipe],
})
export class CardBottomComponent {
  @Input() public cardData: Card;
}
